function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { UserSegment } from '@shared/Models';
import { Constants } from '@shared/utils/constants';
import { enrichReviewCommentsApiVersion } from '@shared/specifics';
const initialAppReviewsDataState = {
    entityId: '',
    reviews: [],
    isPurchased: false,
    reviewComments: {},
    markedAsHelpful: {
        userReviewIdsMarkedAsHelpful: [],
        userReviewIdsLoading: {}
    }
};
// add your feature flags here
// for now the type should be string
// we can explore other types in the future
// DON'T FORGET to initialize it in the constructor
// ALSO DON'T FORGET to initialize it in the initial state
// your new feature flag value will be automatically update in
// state.config.featureFlags.myNewFeatureFlag
export class IFeatureFlags {
    constructor(){
        // i.e. myNewFeatureFlag: string;
        _define_property(this, "AppReviews", void 0);
        _define_property(this, "ProfileExp", void 0);
        _define_property(this, "AltAuth", void 0);
        _define_property(this, "SaasLinkingEnabled", void 0);
        _define_property(this, "RedesignEnabled", void 0);
        _define_property(this, "ShowPopularity", void 0);
        _define_property(this, "UseSecondarySearch", void 0);
        _define_property(this, "privateOffers", void 0);
        _define_property(this, "purchaseBlends", void 0);
        _define_property(this, "newCustomerFlow", void 0);
        _define_property(this, "PartnersEnabled", void 0);
        _define_property(this, "forceCompletePurchase", void 0);
        _define_property(this, "allowAdminUser", void 0);
        _define_property(this, "showConsent", void 0);
        _define_property(this, "ensureprewarm", void 0);
        _define_property(this, "useSearchV2", void 0);
        _define_property(this, "ReviewsMyCommentsFilter", void 0);
        _define_property(this, "sortByRecentlyUpdatedEnabled", void 0);
        _define_property(this, "sortByRatingEnabled", void 0);
        _define_property(this, "allNewSortsEnabled", void 0);
        _define_property(this, "I18nextEnabled", void 0);
        _define_property(this, "cloudMarketplaceModeOn", void 0);
        _define_property(this, "recommendations", void 0);
        _define_property(this, "openInNewWindowButton", void 0);
        _define_property(this, "logToConsole", void 0);
        _define_property(this, "expredirect", void 0);
        _define_property(this, "partnersTestMode", void 0);
        _define_property(this, "serverBypass", void 0);
        _define_property(this, "cloudMarketplaceModeFF", [
            'newHeader'
        ]);
        _define_property(this, "activeCloudMarketplaceFeatures", ()=>{
            if (this.cloudMarketplaceModeOn) {
                this.cloudMarketplaceModeFF.forEach((ff)=>{
                    this[`${ff}`] = true;
                });
            }
        });
        // i.e. this.myNewFeatureFlag = 'false';
        this.AppReviews = 'false';
        this.ProfileExp = 'false';
        this.AltAuth = 'false';
        this.SaasLinkingEnabled = 'false';
        this.RedesignEnabled = 'false';
        this.ShowPopularity = 'false';
        this.UseSecondarySearch = 'false';
        this.privateOffers = 'false';
        this.purchaseBlends = 'false';
        this.newCustomerFlow = 'false';
        this.PartnersEnabled = 'false';
        this.forceCompletePurchase = 'false';
        this.allowAdminUser = 'false';
        this.showConsent = 'false';
        this.ensureprewarm = 'false';
        this.useSearchV2 = 'false';
        this.ReviewsMyCommentsFilter = 'true';
        this.sortByRecentlyUpdatedEnabled = 'false';
        this.sortByRatingEnabled = 'false';
        this.allNewSortsEnabled = 'false';
        this.I18nextEnabled = 'false';
        this.cloudMarketplaceModeOn = false;
        this.recommendations = true;
        this.openInNewWindowButton = false;
        this.logToConsole = false;
        this.expredirect = false;
        this.partnersTestMode = false;
        this.serverBypass = false;
    }
}
export const initialUserFavouriteState = {
    fetchDataStatus: Constants.UserFavourite.FetchDataStatus.Invalid,
    apps: [],
    services: []
};
export const initialDynamicCampaignState = {
    html: ''
};
export const initialSearchState = {
    searchText: '',
    searchSortingOption: Constants.SearchSortingOption.BestMatch,
    appSearchResults: [],
    servicesSearchResults: [],
    filteredAppSearchResults: [],
    filteredServicesSearchResults: [],
    filteredCloudsIndustrySearchResults: [],
    appsCount: 0,
    servicesCount: 0,
    cloudsIndustryCount: 0,
    searchIdCurrentlyOngoing: 0,
    partnerSearchResults: [],
    requestId: Constants.ReservedCorrelationIds.EmptyId
};
export const initialModalState = {
    appId: '',
    parnerId: '',
    modalId: 0,
    isSignedIn: false,
    showModal: false,
    payload: null,
    entityType: Constants.EntityType.App,
    isOpenedFromPDP: false
};
export const initialEntityDataState = {
    idMap: {},
    dataList: [],
    dataMap: {},
    dataMapLoaded: false,
    entityIdFailed: '',
    entityIdLoading: '',
    activeFilters: [],
    count: 0,
    curatedData: {},
    dataLoaded: {},
    curatedDataLoaded: {},
    subsetData: [],
    subsetSearchQuery: '',
    tileDataRequestId: '',
    relatedAppsItems: {
        entityId: '',
        items: {
            suggestedItems: [],
            saasLinkingItems: [],
            linkedAddIns: []
        }
    },
    appReviewsData: initialAppReviewsDataState,
    linkedInProductGroup: null
};
export const initialAppDataState = {
    idMap: {},
    dataList: [],
    dataMap: {},
    dataMapLoaded: false,
    entityIdFailed: '',
    entityIdLoading: '',
    activeFilters: [],
    count: 0,
    curatedData: {},
    dataLoaded: {},
    pricingPayload: null,
    partnerAppDataLoaded: false,
    curatedDataLoaded: {},
    subsetData: [],
    subsetSearchQuery: '',
    tileDataRequestId: '',
    relatedAppsItems: {
        entityId: '',
        items: {
            suggestedItems: [],
            saasLinkingItems: [],
            linkedAddIns: []
        }
    },
    appReviewsData: initialAppReviewsDataState,
    linkedInProductGroup: null,
    featuredApps: {
        homepage: [],
        gallery: []
    }
};
export const initialCloudsIndustryDataState = {
    idMap: {},
    dataList: [],
    dataMap: {},
    dataMapLoaded: false,
    entityIdFailed: '',
    entityIdLoading: '',
    activeFilters: [],
    count: 0,
    curatedData: {},
    dataLoaded: {},
    pricingPayload: null,
    curatedDataLoaded: {},
    subsetData: [],
    subsetSearchQuery: '',
    tileDataRequestId: '',
    relatedAppsItems: {
        entityId: '',
        items: {
            suggestedItems: [],
            saasLinkingItems: [],
            linkedAddIns: []
        }
    },
    appReviewsData: initialAppReviewsDataState,
    linkedInProductGroup: null
};
export const initialUserDataState = {
    assignmentContext: '',
    id: '',
    group: [
        ''
    ],
    signedIn: false,
    idToken: '',
    idTokenPayload: '',
    accessToken: {},
    refreshToken: '',
    firstName: '',
    lastName: '',
    uniqueName: '',
    displayName: '',
    oid: '',
    tid: '',
    puid: '',
    email: '',
    graphApi: process.env.graphApi,
    alternateEmail: '',
    isMSAUser: false,
    userSegment: UserSegment.unauthenticated,
    hasReview: false,
    fieldHubUserType: Constants.FieldHubUserType.None,
    isLoadingUserProfile: false,
    loading: true,
    givenName: '',
    familyName: '',
    profile: {
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        country: '',
        company: '',
        title: '',
        updateRequired: null,
        isLatestProfile: false,
        uiRole: null,
        managedLicenses: []
    },
    tenantsDetails: {
        details: {
            countryCode: null,
            defaultDomain: null,
            displayName: null,
            domains: null,
            id: null,
            tenantCategory: null,
            tenantId: null,
            tenantType: null,
            azureSubscriptions: {}
        },
        status: {
            hasError: false,
            isLoading: false
        }
    },
    purchases: {},
    privateOffers: {
        dataList: [],
        loading: true
    },
    roleDefinitions: [],
    accounts: {
        isEAAccount: false,
        isLoading: false,
        accounts: null,
        hasError: false
    },
    isMaccTenant: false
};
export const initialExperimentState = {
    abTestingVersion_AMP: Constants.VaritionKey.Default,
    abTestingVersion_newFilterAMP: Constants.VaritionKey.Default
};
export const initialConfigState = {
    initLoading: true,
    isEmbedded: false,
    experiment: initialExperimentState,
    embedHost: null,
    locStrings: '',
    locale: 'en-us',
    user: '',
    flightCodes: null,
    partnersIframeUrl: '',
    partnersApiHost: '',
    partnersIframeUrlTest: '',
    correlationId: '',
    currentView: 'home',
    isSearchInHero: true,
    landingView: '',
    currentGalleryViewIsCurated: false,
    breadcrumbUrl: null,
    appViewTelemetryLoggedCount: 0,
    nationalCloud: '',
    billingCountryCode: 'us',
    privatePricingDataLoaded: false,
    featureFlags: new IFeatureFlags(),
    marketplaceApiHost: '',
    saasRPHost: '',
    MPRPHost: '',
    armApiHost: '',
    isMobile: false,
    isAppSource: process.env ? process.env.applicationTarget === Constants.appSourceApplicationTargetName : false,
    pidlEnv: '',
    query: {},
    requestFilteredLoading: false,
    requestFilteredEntityType: Constants.TileDataEntityType.All,
    requestFilteredQuery: {},
    responseFilteredQuery: {},
    cookiesConsent: {
        isManageModalOpen: false,
        WCPConsent: {
            Advertising: false,
            Analytics: false,
            Required: true,
            SocialMedia: false
        },
        isConsentRequired: false
    },
    siteEnvironment: '',
    agorasEnvironment: '',
    newNpsEnabled: false,
    pcaInstanceInitialized: false,
    npsLogicVerified: false,
    reviewsAPIVersion: enrichReviewCommentsApiVersion,
    showContextPanel: false,
    commerceApiHost: '',
    storefrontName: null,
    marketplaceLeadsHost: '',
    marketplaceLeadsAudienceId: '',
    agreementAppId: '',
    startingPricingData: {}
};
export const initialServiceDataState = {
    idMap: {},
    dataList: [],
    countriesList: {},
    dataMap: {},
    dataMapLoaded: false,
    entityIdFailed: '',
    entityIdLoading: '',
    activeFilters: [],
    count: 0,
    curatedData: {},
    dataLoaded: {},
    curatedDataLoaded: {},
    subsetData: [],
    subsetSearchQuery: '',
    tileDataRequestId: '',
    entityType: Constants.EntityType.Service,
    selectedCountry: Constants.usCountryCode.toUpperCase(),
    selectedRegion: Constants.allStatesCode.toUpperCase(),
    relatedAppsItems: {
        entityId: '',
        items: {
            suggestedItems: [],
            saasLinkingItems: [],
            linkedAddIns: []
        }
    },
    appReviewsData: initialAppReviewsDataState,
    linkedInProductGroup: null
};
export const initialCheckoutState = {
    items: [],
    customers: null,
    activeCustomer: null,
    publisherToken: null,
    error: false,
    currentStep: 0,
    purchaseAttempt: 0,
    billingAddress: null,
    checkoutId: '',
    isNDIEnabled: false
};
export const initialPartnersState = {
    filterLocation: null,
    contactDetails: null
};
export const initialState = {
    search: initialSearchState,
    modal: initialModalState,
    apps: initialAppDataState,
    cloudsIndustry: initialCloudsIndustryDataState,
    users: initialUserDataState,
    config: initialConfigState,
    services: initialServiceDataState,
    dynamicCampaign: initialDynamicCampaignState,
    userFavourite: initialUserFavouriteState,
    checkout: initialCheckoutState,
    partners: initialPartnersState
};
export function deepCopyDataMap(DataMap) {
    const newDataMap = {};
    if (Array.isArray(DataMap)) {
        return [
            ...DataMap
        ];
    } else if (DataMap == null || typeof DataMap !== 'object') {
        return DataMap;
    } else if (DataMap.count === 0) {
        return null;
    }
    for(const k in DataMap){
        const prop = DataMap[`${k}`];
        const copy = deepCopyDataMap(prop);
        if (copy) {
            newDataMap[`${k}`] = copy;
        }
    }
    return newDataMap;
}
export function copyState(oldState) {
    const newState = {};
    for(const k in oldState){
        // @ts-expect-error index type T
        newState[`${k}`] = oldState[`${k}`];
    }
    return newState;
}
